module.exports = __webpack_public_path__ + "media/fonts/Oricons-c8fccf37f6956a0d965373f24958b4b4.woff";